import React from "react";
import Helmet from "react-helmet";
import PropTypes from "prop-types";

// Import global styles
import "normalize.css";
import "../assets/styles/globalStyles.scss";

import styles from "../assets/styles/NetworkLayout.module.scss";

import NetworkNavigation from "./NetworkNavigation";

const NetworkLayout = ({ children, title, trail }) => {
	return (
		<div className={styles.root}>
			<Helmet htmlAttributes={{ lang: "en" }} defaultTitle={title} />

			<nav className={styles.navigation}>
				<NetworkNavigation trail={trail} />
			</nav>
			<div className={styles.container}>
				<main className={styles.content}>{children}</main>
			</div>
		</div>
	);
};

NetworkLayout.propTypes = {
	children: PropTypes.node.isRequired
};

export default NetworkLayout;
